import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import {
    SvgIconGrupoCoberturaSeguroVidaMorte,
    SvgIconGrupoCoberturaSeguroVidaInvalidezAcidente,
    SvgIconGrupoCoberturaSeguroVidaInvalidezDoenca,
    SvgIconGrupoCoberturaSeguroVidaDoencasGraves,
    SvgIconGrupoCoberturaSeguroVidaIncapacidadeTemporaria,
    SvgIconGrupoCoberturaSeguroVidaFuneral,
    SvgIconGrupoCoberturaSeguroVidaAssistencia,
} from '../../../business-components/SvgIcon/SvgIconSeguroVida/SvgIconSeguroVida'

import {
    StepperPadrao
} from '../../../business-components/Stepper/Stepper'

import {
    grupoCoberturaSeguroVida1aParteList,
    grupoCoberturaSeguroVida2aParteList,
} from '../../../business-rules/List/SeguroVida/grupoCoberturaSeguroVidaList'

 import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import SeguroVidaFormSeguroVidaApolice from './SeguroVidaFormSeguroVidaApolice'

import {
    processaRegistrosDefaultIniciaisSeguroVida,
    incluiSeguroVidaSeguroVidaEmGrupo,
//    calculaTotaisSeguroVida,
} from './SeguroVidaService'

const SeguroVidaForm = ({ variaveisGlobais, values, handleChange, setFieldValue, vars, popupApolice, arquivoList }) => {

    const stepsSvgIcon = [
        SvgIconGrupoCoberturaSeguroVidaMorte,
        SvgIconGrupoCoberturaSeguroVidaInvalidezAcidente,
        SvgIconGrupoCoberturaSeguroVidaInvalidezDoenca,
        SvgIconGrupoCoberturaSeguroVidaDoencasGraves,
        SvgIconGrupoCoberturaSeguroVidaIncapacidadeTemporaria,
        SvgIconGrupoCoberturaSeguroVidaFuneral,
        SvgIconGrupoCoberturaSeguroVidaAssistencia,
    ]

    let steps = []

    grupoCoberturaSeguroVida1aParteList?.forEach( (linhaGrupoCoberturaSeguroVida1aParteList, index) => {
        
        steps.push(linhaGrupoCoberturaSeguroVida1aParteList)
    })

    steps[0] = LABEL.morteAcidental

    const stepsTitle2 = grupoCoberturaSeguroVida2aParteList

    const stepsContent = [
        <SeguroVidaFormSeguroVidaApolice
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaFormSeguroVidaApolice
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaFormSeguroVidaApolice
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaFormSeguroVidaApolice
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaFormSeguroVidaApolice
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaFormSeguroVidaApolice
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaFormSeguroVidaApolice
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
    ]

    const valuesStepsTitle2 = [
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
    ]

    incluiSeguroVidaSeguroVidaEmGrupo(values)

    //calculaTotaisSeguroVida(values)

    return (
        <>
            <PanelRadioGroup
                name="familiarSeguroVida"
                value={Number.parseInt(values.familiarSeguroVida) || '1'}
                onChange={(e) => {
                    handleChange(e)
                }}
                list={values.totalSeguroVida}
                onBlur={
                    processaRegistrosDefaultIniciaisSeguroVida(values,
                        Number.parseInt(values.familiarSeguroVida))
                }
                helpText={HELPTEXT.seguroVidaPanelRadioGroup}
            />

            {popupApolice
                ?
                    <SeguroVidaFormSeguroVidaApolice
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        vars={vars}
                        arquivoList={arquivoList}
                        popupApolice={popupApolice}
                    />
                :
                    <StepperPadrao
                        stepsType={"cardValor"}
                        stepsSvgIcon={stepsSvgIcon}
                        steps={steps}
                        stepsTitle2={stepsTitle2}
                        stepsContent={stepsContent}
                        valuesStep={values.stepSeguroVida}
                        valuesStepsValor={values.stepsValorSeguroVida}
                        valuesStepsTitle2={valuesStepsTitle2}
                        valuesStepsValor2={values.stepsValor2SeguroVida}
                        naoPermiteConcluir={true}
                    />
            }
        </>
    )
}

export default SeguroVidaForm